import { Component } from '@angular/core';
import { EChartsOption } from 'echarts';

@Component({
	selector: 'app-dashboard-chart-gauge',
	standalone: false,
	templateUrl: './dashboard-chart-gauge.component.html',
	styleUrl: './dashboard-chart-gauge.component.scss'
})
export class DashboardChartGaugeComponent {

	options: EChartsOption = {
		series: [{
			type: 'gauge',
			progress: { show: true },
			detail: { valueAnimation: true, formatter: '{value}%' },
			data: [{ value: 72, name: 'Completion' }]
		}]
	};

}
